import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/pro-regular-svg-icons";
import Skeleton from "react-loading-skeleton";

import Typography from "core/components/Typography";
import { Row } from "core/styles";

/**
 * Org name and ID shown above the subnav on the org details page.
 *
 * Extracted from OrganizationLayout so the truncation behaviour can be measured
 * in a browser test — see OrganizationHeading.browser.test.jsx, which renders it
 * inside the same AdjustableColumn/Column wrapper the layout uses.
 *
 * Long names have to ellipsis rather than spill into the page area. That needs
 * all three of the rules below; drop any one and the name overflows again.
 */
const OrganizationHeading = ({ organization, isLoading }) => (
  <Row
    gap="12px"
    alignItems="start"
    // Column sets align-items:start, making this Row a non-stretched flex item,
    // and such an item takes its max-content width — which is NOT clamped to the
    // sidebar. Without a definite width it grows to fit the whole name and
    // spills out, and nothing inside it ever has a reason to shrink.
    style={{ width: "100%" }}
    data-test="organization-heading"
  >
    <FontAwesomeIcon
      icon={faBuilding}
      style={{
        width: "36px",
        height: "38px",
        padding: "7px 8px",
        paddingBottom: "7px",
        color: "#fff",
        backgroundColor: "#D68712",
        borderRadius: "5px",
      }}
    />
    {/* Flex children refuse to shrink below their content by default. */}
    <div style={{ alignItems: "center", minWidth: 0 }}>
      <Typography
        variant="h3"
        noMargin
        // The h3 variant already carries overflow:hidden + text-overflow:ellipsis,
        // but neither does anything until the text is kept on one line.
        style={{ marginBottom: "4px", whiteSpace: "nowrap" }}
        data-test="organization-name"
      >
        {isLoading ? (
          <Skeleton style={{ width: "100px" }} />
        ) : (
          `${organization?.name || "n/a"}`
        )}
      </Typography>
      <span
        style={{
          maxWidth: "230px",
          fontSize: "18px",
          fontWeight: 400,
        }}
      >
        {isLoading ? (
          <Skeleton style={{ width: "150px" }} />
        ) : (
          `ID: ${organization?.id || "—"}`
        )}
      </span>
    </div>
  </Row>
);

export default OrganizationHeading;
